// @flow

import React from 'react';
import { connect } from 'react-redux';

import LoginForm from 'app/login/components/LoginForm';

const Description = () => (
  <span>
    <p>Your account is now locked.</p>
    <p>
      Please <a href="/app/login/forgot">reset your password</a> to unlock your
      account.
    </p>
  </span>
);

const mapStateToProps = () => {
  return {
    title: 'Login Locked',
    description: <Description />,
    shouldShowSubmitButton: false,
    shouldShowLoginForm: true,
  };
};

const mapDispatchToProps = () => {
  return {};
};

const LockedFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);

export default LockedFormContainer;
